import NationalCover from '../../../assets/nationalCover.png'
import FrenchTeam from '../../../assets/frenchTeam.png'
import Mission from '../../../assets/mission.png'
import Satisfaction from '../../../assets/satisfaction.png'

export const Data = [
  {
    key: 'NationalCover',
    title: 'Une couverture nationale',
    text: 'Des Bras En Plus est un réseau national de 250 déménageurs réparti sur toute la France',
    img: NationalCover,
  },
  {
    key: 'Satisfaction',
    title: 'La satisfaction client',
    text: 'Une note moyenne de 4,6/5 sur près de 3000 clients',
    img: Satisfaction,
  },
  {
    key: 'Mission',
    title: 'Une entreprise à Mission',
    text: 'Des Bras En Plus agit pour une mobilité responsable et accessible au plus grand nombre',
    img: Mission,
  },
  {
    key: 'FrenchTeam',
    title: 'Le Made in France',
    text: 'Des Bras En Plus est une entreprise française qui soutient un savoir faire local et engagé',
    img: FrenchTeam,
  },
]
